/**
 * 메뉴 요소에 대한 타입
 */
export const DnD_element_type_menu = {
  ELEMENT : {
    MESSAGE : "_MESSAGE",
    SLIDE_PAGE : "_SLIDE_PAGE"
  },
  COMPONENT : {
    NORMAL : {
      TEXT : "_TEXT",
      BUTTON : "_BUTTON",
      IMAGE : "_IMAGE",
      GROUP : "_GROUP"
    },
    SPECIAL : {
      ADDR : "_ADDR",
      TEL : "_TEL",
      DATE : "_DATE"
    }
  }
}